<div>
<ckeditor #myEditor [editor]="Editor" [config]="config" data="<h1>1.1 Section</h1>" (ready)="onReady($event)" (change)="onChange($event)"></ckeditor>
</div>